module.exports = __webpack_public_path__ + "img/icon-food.1b642727.svg";